<script lang="ts">
  import type { App } from '$lib/types';

  import FormControl from '$components/FormControl.svelte';
  import IconWrapper from '$mds/IconWrapper';
  import { tooltip } from '$lib/directives/tooltip';

  import { createEventDispatcher, getContext } from 'svelte';
  import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
  import { capitalize } from '$lib/utils';
  const dispatch = createEventDispatcher();

  const { irkAccount } = getContext<App>('app');

  export let id = 'payment-metafy-credit';
  export let size: 'sm' | 'lg' = 'sm';
  export let payWithCredit = false;
  export let message = `Use credit to cover Metafy ${capitalize($irkAccount?.metafyPartnerType ?? 'Partner')} costs`;
  export let tooltipContent =
    "Your earned credits must cover the entire cost of Metafy Partner, including subscription and applicable taxes. If your balance is insufficient, we'll charge the payment method on file.";

  let className = '';
  export { className as class };
</script>

<div class="flex items-center {className}">
  <FormControl
    {id}
    type="toggle"
    isBigToggle={size === 'lg'}
    bind:checked={payWithCredit}
    on:change={() => {
      dispatch('toggle', payWithCredit);
    }}
  />
  <label for={id} class="text-ondark-primary text-body-xs ml-3 text-pretty align-middle">
    {message}
  </label>
  <span
    use:tooltip={{
      content: tooltipContent,
      placement: 'top-end'
    }}
    class="relative ml-2 before:absolute before:-inset-2"
  >
    <IconWrapper icon={faInfoCircle} class="text-ondark-secondary" />
  </span>
</div>
